/*Generated from the `:::slide{key="45b9b52e-05d0-4e1e-89db-3c8e65f541c6" slug="y-in-finals"}` (simplified/001-P1/005/一.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.em) _missingMdxReference("html.em", true);
  if (!html.li) _missingMdxReference("html.li", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  if (!html.ul) _missingMdxReference("html.ul", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      count: "3",
      children: _jsxs(html.p, {
        children: ["The syllable ", _jsx(html.em, {
          children: "yī",
          components: html
        }), " only consists of a ", _jsx(html.strong, {
          children: "final",
          components: html
        }), "—the vowel \"i\" (pronounced like English \"ee\"; think \"", _jsx(html.strong, {
          children: "I",
          components: html
        }), "an\")."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      keepWithNext: "true",
      count: "3",
      children: _jsx(html.p, {
        children: "The \"y\" is purely a spelling convention used for lone finals that begin with \"i\":",
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "ul",
      count: "3",
      children: _jsxs(html.ul, {
        children: [_jsx(html.li, {
          children: "-i -> yi",
          components: html
        }), _jsx(html.li, {
          children: "-ing -> ying",
          components: html
        }), _jsx(html.li, {
          children: "-ia -> ya",
          components: html
        }), _jsx(html.li, {
          children: "-iao -> yao",
          components: html
        }), _jsx(html.li, {
          children: "-ie -> ye",
          components: html
        }), _jsx(html.li, {
          children: "-iong -> yong",
          components: html
        }), _jsx(html.li, {
          children: "...",
          components: html
        })]
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
